import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import scope from '../views/scope.vue'
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path: '/scope',
    name: 'scope',
    component:scope
  },
  {
    path: '/jiangjie',
    name: 'jiangjie',
    component: () => import('../views/jiangjie.vue')
  },
  {
    path: '/zhanlan',
    name: 'zhanlan',
    component: () => import('../views/zhanlan.vue')
  }
  ,
  {
    path: '/huodong',
    name: 'huodong',
    component: () => import('../views/huodong.vue')
  }
  ,
  {
    path: '/wuliao',
    name: 'wuliao',
    component: () => import('../views/wuliao.vue')
  }
  ,
  {
    path: '/confirm',
    name: 'confirm',
    component: () => import('../views/confirm.vue')
  }
  ,
  {
    path: '/paystatus',
    name: 'paystatus',
    component: () => import('../views/paystatus.vue')
  }
  ,
  {
    path: '/zhifusuccess',
    name: 'zhifusuccess',
    component: () => import('../views/zhifusuccess.vue')
  },
  {
    path: '/payfailure',
    name: 'payfailure',
    component: () => import('../views/payfailure.vue')
  },
  {
    path: '/',
    redirect: "/Home"
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
